<template>
  <div class="container">
    <div class="module_section1">
      <div class="banner_cont">
        <div class="subTitle">以技术为核心 · 联接未来能源</div>
        <div class="title">能源数智化· 驱动低碳未来</div>
        <div class="subtitle1">新型能源数字化智能化科技公司</div>
        <a class="btn" href="javascript:;" @click="goToLink('/solution')">
          查看产品解决方案
          <i class="el-icon-right rightIcon1"></i>
        </a>
      </div>
    </div>
    <div class="module_section2 module" id="solution">
      <h3 class="title_com">致力于成为智慧数字能源解决方案的引领者</h3>
      <p class="subTile_com">
        以用户体验为中心，专注于为家庭、工商业用户提供光储充场景一体化服务，建立智慧能源管理平台，让用户享受经济性和生态性共赢的绿色智慧的生活方式，加快能源生态和谐发展
      </p>
      <div class="solution_cont">
        <div class="smart_left">
          <div 
            v-for="(el, ind) in smartList" 
            :key="ind" 
            :class="smartActived === ind ?'actived item' : 'item'"
            @click="handleChangeSmart(ind)">
            <img :src="smartActived === ind ? el.iconActived : el.icon" alt="">
            {{el.abbrTitle}}
          </div>
        </div>
        <div class="smart_right">
          <div class="cont">
            <p class="title">{{smartList[smartActived].title}}</p>
            <p class="content">{{smartList[smartActived].cont}}</p>
            <a href="javascipt:;" class="btn" @click="goToLink(smartList[smartActived].url)">查看详情<i class="el-icon-right rightIcon2"></i></a>
          </div>
          <img class="img" :src="smartList[smartActived].img" alt="">
        </div>
      </div>
    </div>
    <div class="module_section3">
      <div class="product_item" v-for="(el, ind) in productList" :key="ind">
        <img class="bg" :src="el.bg" alt="">
        <div class="content">
          <img class="logo" alt="" src="https://oss.duodians.com/lambda/office_web/banner/logo.png">
          <p class="name">{{el.title}}</p>
          <p class="text">{{el.text}}</p>
          <a href="javascript:;" class="btn" @click="goToLink(el.url)">查看详情<i class="el-icon-right rightIcon2"></i></a>
        </div>
      </div>
    </div>
    <!-- <div class="module_section4">
      <h3 class="title_com">合作伙伴</h3>
      <p class="subTile_com">
        客户包括：振邦智能、汉枫、欣旺达、比亚迪、安克、佳合丰、宝光智中、中国华电等
      </p>
      <div class="partner_cont module">
        <div class="item" v-for="(el, ind) in partnerList" :key="ind">
          <img class="icon" :src="el.img" :style="`width: ${pxToRem(el.width)}`" alt="">
        </div>
      </div>
    </div> -->
    <div class="module_section5 module">
      <h3 class="title_com">合作流程</h3>
      <div class="cooperation_cont">
        <div class="item" v-for="(el, ind) in cooperationList[0]" :key="ind">
          <p class="title">{{el.title}}</p>
          <p class="subTitle" v-html="el.subTitle"></p>
        </div>
        <img class="cooperation_img" src="https://oss.duodians.com/lambda/office_web/index/cooperation_img.png" alt="">
        <div class="item" v-for="(el, ind) in cooperationList[1]" :key="ind + 10">
          <p class="title">{{el.title}}</p>
          <p class="subTitle" v-html="el.subTitle"></p>
        </div>
      </div>
    </div>
    <div class="module_section6" id="applyUse">
      <p class="title_com">让能源数智化更简单，更方便</p>
      <p class="subTile_com">专业的咨询团队为您提供全方位1对1的贴心服务，助您能源数智化转型！</p>
      <div class="contact_cont module">
        <p class="title">请填写真实信息，我们将有专属顾问联系你</p>
        <div class="name_cont">
          <input class="input" v-model="msg.name" placeholder="输入您的姓名" type="text">
        </div>
        <div class="iphone_cont">
          <input class="input" v-model="msg.phone" placeholder="输入手机号" type="text">
          <a href="javascript:;" class="btn" @click="onSubmit">立即提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../api/config'
export default {
  data() {
    return {
      smartList: [
      {
        title: 'EMS智慧能源管理系统',
        abbrTitle: 'EMS智慧能源管理系统',
        cont: '实现对能源微网和光储充电站的设备数据采集和协调控制，为系统安全、稳定、高效运行提供保障，使经济效益有效提高。通过Energy AI技术，对海量能源运行数据进行采集和深度分析，实现精准的需求侧响应、发电量预测、运营预测，致力于推动与实现“碳达峰、碳中和”目标',
        icon: 'https://oss.duodians.com/lambda/office_web/index/smartIcon2.png',
        iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartActivedIcon2.png',
        img: 'https://oss.duodians.com/lambda/office_web/index/smart2.png',
        url: '/solution'
      },  
      {
        title: '储能电池数据监测平台',
        abbrTitle: '储能电池数据监测平台',
        cont: '严格遵循全生命周期理念，实时采集电池内电压、温度、内阻、报警等数据，实现准确监控和云端运维，全面保障电池安全与寿命；针对动力电池储能项目，建立电池一致性管理和溯源系统，实时监测电池性能参数，定期进行维护和安全评估，通过大数据电池AI预警，协助用户做好应急预案',
        icon: 'https://oss.duodians.com/lambda/office_web/index/smartIcon3.png',
        iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartActivedIcon3.png',
        img: 'https://oss.duodians.com/lambda/office_web/index/smart3.png',
        url: '/platform'
      },
      {
        title: '虚拟电厂VPP',
        abbrTitle: '虚拟电厂VPP',
        cont: '虚拟电厂VPP（Virtual Power Plant），以储能为核心，由电池AI、能源AI和物联网技术赋能；通过EMS智慧能源管理系统协同，实现分钟级、秒级响应的直控型虚拟电厂，参与需求侧响应、负荷聚合管理、电力现货市场和电网辅助服务',
        icon: 'https://oss.duodians.com/lambda/office_web/index/smartIcon1.png',
        iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartActivedIcon1.png',
        img: 'https://oss.duodians.com/lambda/office_web/index/smart1.png',
        url: '/virtualPower'
      },
     ],
      smartActived: 0,
      productList: [{
        title: 'Energy AI',
        text: '让能源数字化·让数字价值化',
        bg: 'https://oss.duodians.com/lambda/office_web/index/productBg_01.jpg',
        url: '/energy'
      }, {
        title: 'Battery AI',
        text: '实现电池全生命周期优化和能源价值提升',
        bg: 'https://oss.duodians.com/lambda/office_web/index/productBg_02.jpg',
        url: '/battery'
      }, {
        title: '能源物联网',
        text: '为能源设备提供安全可靠的连接通信能力',
        bg: 'https://oss.duodians.com/lambda/office_web/index/productBg_03.jpg',
        url: '/product'
      }],
      partnerList: [{
        img: 'https://oss.duodians.com/lambda/office_web/index/partner01.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner02.png',
        width: 144
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner03.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner04.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner05.png',
        width: 167
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner06.png',
        width: 236
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner07.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner08.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner09.png',
        width: 167
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner10.png',
        width: 236
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner11.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner12.png',
      }, {
        img: 'https://oss.duodians.com/lambda/office_web/index/partner13.png',
      }],
      cooperationList: [[{
        title: '沟通需求',
        subTitle: '了解项目背景<br/>提交开发需求',
      }, {
        title: '制定方案',
        subTitle: '评估需求<br/>提供咨询建议及解决方案',
      }, {
        title: '合作立项',
        subTitle: '客户选择可行方案<br/>双方签约',
      }], [{
        title: '开发对接',
        subTitle: '开展研发工作<br/>追踪项目进度',
      }, {
        title: '项目交付',
        subTitle: '样品测试联调<br/>产测后投放市场',
      }, {
        title: '售后运维',
        subTitle: '提供免费操作培训<br/>保证系统正常运营',
      }]],
      msg: {
        name: '',
        phone: ''
      }
    };
  },
  components: {},

  computed: {
    _isMobile() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return "mobile_video";
      } else {
        return "pc_video";
      }
    }
  },
  watch:{
    $route:{
      immediate:true,
      handler(){
        //地址栏发生改变，该函数会执行
        let name = window.location.hash.split('#')[1]
        if (name.indexOf('id=')) {
          name = name.split('id=')[1]
        }
        if (name) {
          this.$nextTick(() => {
            const element = document.getElementById(name);
            element.scrollIntoView({block: 'start', behavior: 'smooth'});
          })
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    async onSubmit() {
      if (!this.msg.name) return this.$message.error('请填写姓名')
      if (!this.msg.phone) return this.$message.error('请填写联系方式')
      if (!(/^1[3|4|5｜6|9|7|8][0-9]{9}$/.test(this.msg.phone))) {
        return this.$message.error('请填写正确的手机号')
      } 
      this.sendLogMsg(this.msg)
    },
    async sendLogMsg (msg) {
      const url = '/api/robot/send?access_token=accb39e6ee523d7d609da90afb7ce6a6126e88bb1535aa8c1ae7be6d06c47dcb'
      const currentTime = new Date().toLocaleString()
      try {
        let sendmsg = {
          msgtype: 'markdown',
          markdown: {
            title: msg.name + '',
            text: '#### '+ msg.name+'在哆点官网留下了联系方式' + '\n\r手机号:' + msg.phone + '\n\r提交时间:' + currentTime
          }
        }
        axios.post(url, sendmsg)
        this.$message({
          message: '提交成功，咨询团队稍后会联系您',
          type: 'success'
        });
      } catch (error) {
      }
    },
    handleChangeSmart(ind) {
      this.smartActived = ind
    },
    goToApplyUse() {
      const element = document.getElementById('applyUse');
      element.scrollIntoView({block: 'start', behavior: 'smooth'});
    },
    goToLink(url) {
      this.$router.push({ path: url })
    }
  }
};
</script>

<style lang='less' scoped>
.rightIcon1{
  font-size: 20px;
  margin-left: 10px;
}
.rightIcon2{
  font-size: 16px;
  margin-left: 6px;
}
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  margin-bottom: -80px;
  .module{
    width:1300px;
    margin: 0 auto;
  }
  .title_com{
    font-size: 46px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #000000;
    line-height: 66px;
    padding: 100px 0 12px;
  }
  .subTile_com{
    margin: 0 auto 0;
    width: 850px;
    height: 62px;
    opacity: 0.6;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 30px;
  }
  .module_section1{
    height: 960px;
    background: url('https://oss.duodians.com/lambda/office_web/index/section1_bg.jpg');
    background-size: 100% 100%;
    .banner_cont{
      padding-top: 310px;
      .title{
        margin-top: 24px;
        height: 82px;
        background-image: linear-gradient(148deg,#4cddbd 13%, #06f286 93%);
        -webkit-background-clip: text;
        color: transparent;//默认颜色设置透明
        font-size: 66px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: center;
        line-height: 82px;
        letter-spacing: 1.6px;
      }
      .subTitle{
        height: 30px;
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .subtitle1{
        margin-top: 50px;
        height: 42px;
        font-size: 32px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 42px;
      }
      .btn{
        margin: 50px auto 0;
        width: 200px;
        height: 50px;
        border: 2px solid;
        border-radius: 32px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
  }
  .module_section2{
    height: 960px;
    .solution_cont{
      margin-top: 90px;
      width: 1300px;
      height: 540px;
      // background: linear-gradient(180deg,#ffffff, #ffffff);
      // border: 16px solid #f0f8fd;
      border-radius: 30px;
      // backdrop-filter: blur(20px);
      background: url('https://oss.duodians.com/lambda/office_web/index/section2_bg.png') #f6fafd ;
      background-size: 100% 100%;
      padding: 16px;
      display: flex;
      .smart_left{
        width: 300px;
        height: 508px;
        background: #ffffff;
        border-radius: 30px 9px 9px 30px;
        padding: 45px 16px 0 34px;
        box-sizing: border-box;
        margin-right: 10px;
        .item{
          cursor: pointer;
          margin-bottom: 20px;
          width: 245px;
          height: 50px;
          opacity: 1;
          background: #f8fffc;
          border: 1px solid #4cddbd;
          border-radius: 8px;
          box-shadow: 0px 1px 5px 0px #ffffff inset; 
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: 30px;
          display: flex;
          align-items: center;
          img{
            width:16px;
            margin: 0 7px 0 16px;
          }
        }
        .actived{
          width: 238px;
          background: url('https://oss.duodians.com/lambda/office_web/index/smartActived_bg.png');
          background-size: 100% 100%;
          border: 0;
        }
      }
      .smart_right{
        flex: 1;
        display: flex;
        .cont{
          margin: 80px 0 0 50px;
          .title{
            height: 34px;
            font-size: 32px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: #000000;
            line-height: 34px;
          }
          .content{
            margin-top: 33px;
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: justify;
            color: #000000;
            line-height: 28px;
            letter-spacing: 0.08px;
          }
          .btn{
            margin-top: 57px;
            width: 138px;
            height: 38px;
            opacity: 1;
            background: #000000;
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: #ffffff;
          }
        }
        img{
          width: 476px;
          height: 460px;
          margin: 24px 34px 0 50px;
          margin-top: 24px;
          margin-right: 34px;
        }
      }
    }
  }
  .module_section3{
    width:100%;
    height: 960px;
    display: flex;
    .product_item{
      flex: 1;
      position: relative;
      .bg{
        width:100%;
        position: absolute;
      }
      .content{
        position: absolute;
        padding: 100px 80px;
        .logo{
          width:77px;
        }
        .name{
          margin-top: 230px;
          font-size: 44px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: left;
          color: #ffffff;
          line-height: 54px;
        }
        .text{
          margin-top: 40px;
          font-size: 22px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: justify;
          color: #ffffff;
          line-height: 28px;
          letter-spacing: 0.12px;
        }
        .btn{
          margin-top: 100px;
          width: 138px;
          height: 38px;
          border: 2px solid #ffffff;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #ffffff;
        }
      }
      
    }
  }
  .module_section4{
    height: 960px;
    background: url('https://oss.duodians.com/lambda/office_web/index/section4_bg.png') #f6fafd ;
    background-size: 60% 100%;
    background-position: right top;
    background-repeat: no-repeat;
    .partner_cont{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 80px;
      .item{
        width: 236px;
        height: 130px;
        margin-bottom: 30px;
        margin-right: 30px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        .icon{
          width:180px;
        }
      }
      .item:nth-child(5n){
        margin-right: 0;
      }
      .item:last-child{
        margin-right: 0;
      }
    }
  }
  .module_section5{
    height: 960px;
    .cooperation_cont{
      display: flex;
      flex-wrap:wrap;
      margin-top: 80px;
      .cooperation_img{
        width:1200px;
        margin: 30px 0;
      }
      .item{
        width: 400px;
        text-align: center;
        .title{
          font-size: 24px;
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: 600;
          text-align: center;
          color: rgba(0,0,0,.85);
          line-height: 38px;
          margin-bottom: 14px;
        }
        .subTitle{
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: rgba(0,0,0,.65);
          line-height: 25px;
        }
      }
    }
  }
  .module_section6{
    height: 688px;
    background-position: center;
    background-size:auto 100%;
    .contact_cont{
      text-align: center;
      background: url('https://oss.duodians.com/lambda/office_web/index/section6_bg.png');
      background-size: 100% 100%;
      height: 320px;
      .title{
        font-size: 28px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 40px;
        padding-top: 80px;
      }
      .name_cont{
        width: 600px;
        height: 50px;
        background: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 27px;
        margin: 30px auto;
        padding: 16px 30px;
        display: flex;
        align-items: center;
        .input{
          height:100%;
          width: 350px;
          font-size: 16px;
          font-family: Montserrat, Montserrat-Medium;
          font-weight: 500;
          color: #1d2129;
        }
        .input:focus{
          outline: 0
        }
      }
      .iphone_cont{
        width: 600px;
        height: 50px;
        background: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 27px;
        margin: 0 auto 24px;
        padding: 16px 0 16px 30px;
        display: flex;
        align-items: center;
        .img{
          width:20px;
          margin-right: 20px;
        }
        .input{
          height:100%;
          width: 350px;
          margin-right: 60px;
          font-size: 16px;
          font-family: Montserrat, Montserrat-Medium;
          font-weight: 500;
          color: #1d2129;
        }
        .input:focus{
          outline: 0
        }
        .btn{
          width: 136px;
          height: 40px;
          background: rgba(0,0,0,.85);
          border-radius: 25px;
          font-size: 16px;
          font-family:  PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .scan_code_btn{
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        width: 248px;
        height: 56px;
        background: #ffffff;
        border: 1.33px solid #ffffff;
        border-radius: 8px;
        margin: 0 auto 40px;
        padding: 14px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgba(0,0,0,1);
        img{
          width: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/index.vue